import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {
  /**
   * @author Malek Motan, 2018
   * @description > This service is used to handles:
   *                1. The session storage mutations such as
   *                getting, setting and deleting content from the browser's session storage.
   *                2. The cookie manipulation methods such as setting, getting and deleting the cookies.
   */
  constructor() {}

  setItem(item, name): void {
    try {
      localStorage[name] = item;
    } catch (e) {
      if (navigator.cookieEnabled) {
        this.setCookie(name, item);
      } else {
        window[name] = item;
      }
    }
  }

  getItem(name) {
    if (localStorage.getItem(name)) {
      return localStorage.getItem(name);
    } else if (this.getCookie(name)) {
      return this.getCookie(name);
    } else if (window[name]) {
      return window[name];
    } else {
      return null;
    }
  }

  deleteItem(name) {
    if (localStorage.getItem(name)) {
      localStorage.removeItem(name);
    } else if (this.getCookie(name)) {
      this.deleteCookie(name);
    } else if (window[name]) {
      window[name] = null;
    }
  }

  setCookie(cname, cvalue) {
    document.cookie = cname + '=' + cvalue + '; path=/';
  }

  getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  deleteCookie(cname) {
    document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/; domain=${this.getCookieDomain()}`;
  }

  getCookieDomain() {
    if (window.location.hostname.includes('.mashvisor.com')) {
      return '.mashvisor.com';
    }
    return 'localhost';
  }
}
